<template>
  <div class="container py-5 d-flex justify-content-center align-items-center min-vh-100">
    <div
      class="login-card p-4 shadow border-primary border rounded-4 bg-white w-100 animate__animated animate__fadeInDown"
      style="max-width: 450px;"
    >
      <!-- 🔙 Back to site -->
      <router-link to="/" class="btn btn-sm btn-outline-secondary mb-4 d-inline-flex align-items-center gap-2">
        <i class="fas fa-arrow-left"></i> Înapoi la site
      </router-link>

      <h2 class="text-center text-primary fw-bold mb-4">
        <i class="fas fa-user-shield me-2"></i> Autentificare Administrator
      </h2>
      <form @submit.prevent="handleLogin">
        <div class="mb-3">
          <label class="form-label fw-semibold">
            <i class="fas fa-user me-1"></i> Username
          </label>
          <input v-model="name" type="text" class="form-control form-control-lg" placeholder="Nume de utilizator" required />
        </div>
        <div class="mb-3">
          <label class="form-label fw-semibold">
            <i class="fas fa-lock me-1"></i> Parolă
          </label>
          <input v-model="password" type="password" class="form-control form-control-lg" placeholder="••••••••" required />
        </div>
        <button type="submit" class="btn btn-primary btn-lg w-100 mt-2 shadow-sm hover-scale">
          <i class="fas fa-sign-in-alt me-2"></i> Autentifică-te
        </button>
      </form>
      <div v-if="error" class="alert alert-danger mt-3 text-center">
        {{ error }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import api from '@/api/axios'

const name     = ref('')
const password = ref('')
const error    = ref('')
const router   = useRouter()

onMounted(() => {
  if (localStorage.getItem('admin_token') === 'admin_fake_token') {
    router.push('/admin/dashboard')
  }
})

async function handleLogin() {
  error.value = ''
  try {
    const res = await api.post('admin-login/', { name: name.value, password: password.value })
    localStorage.setItem('admin_token', res.data.token)
    router.push('/admin/dashboard')
  } catch {
    error.value = 'Date invalide sau eroare de server.'
  }
}
</script>

<style scoped>
.hover-scale { transition: transform 0.2s ease-in-out; }
.hover-scale:hover { transform: scale(1.03); }
.login-card { animation: fadeIn 0.6s ease; }
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(25px); }
  to   { opacity: 1; transform: translateY(0); }
}
</style>